import { render, staticRenderFns } from "./Main_V2.vue?vue&type=template&id=5db21aa0&scoped=true"
import script from "./Main_V2.vue?vue&type=script&lang=js"
export * from "./Main_V2.vue?vue&type=script&lang=js"
import style0 from "./Main_V2.vue?vue&type=style&index=0&id=5db21aa0&prod&scoped=true&lang=css"
import style1 from "./Main_V2.vue?vue&type=style&index=1&id=5db21aa0&prod&scoped=true&lang=css"
import style2 from "./Main_V2.vue?vue&type=style&index=2&id=5db21aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db21aa0",
  null
  
)

export default component.exports